import ModalProvider from "@/components/modal/modal-provider";
import {
  OptionsProvider,
  PollContextProvider,
} from "@/components/poll-context";
import { usePoll } from "@/contexts/poll";

export const LegacyPollContextProvider = (props: React.PropsWithChildren) => {
  const poll = usePoll();

  if (!poll) {
    return null;
  }

  return (
    <PollContextProvider poll={poll}>
      <ModalProvider>
        <OptionsProvider>{props.children}</OptionsProvider>
      </ModalProvider>
    </PollContextProvider>
  );
};
